import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { supabase } from '../../supabaseClient';

const { FiLock, FiUser, FiAlertCircle, FiArrowLeft, FiShield } = FiIcons;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/0fbf60f8fa242397e9ef833782db8ed93045df54e3b36d72437cb9900e44cd21f118b78650ffb5dd82aaaddf0850c39a/images/aW1hZ2UvanBlZw==/f2db29be14ca2eb40f068da8d183a853.jpeg";

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // 1. Check Hardcoded Super Admin Credentials (Oscar)
    if (username === 'Oscar' && password === 'Ramirez123#') {
      // Successful Admin Login
      setTimeout(() => {
        navigate('/admin/dashboard');
      }, 800);
      return;
    }

    // 2. Check Demo Credentials
    if (username === 'admin@ramirez.com' && password === 'admin') {
      setTimeout(() => {
        navigate('/admin/dashboard');
      }, 800);
      return;
    }

    // 3. Try Supabase Auth (if connected)
    if (supabase) {
      try {
        const { data, error } = await supabase.auth.signInWithPassword({
          email: username,
          password,
        });
        if (error) throw error;
        navigate('/admin/dashboard');
        return;
      } catch (err) {
        console.error("Supabase Login Error:", err);
        // Don't return here, fall through to error message
      }
    }

    // If all checks fail
    setError('Invalid Username or Password.');
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4 relative">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden z-0">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-gray-900 via-gray-900 to-blue-900/20"></div>
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl"></div>
      </div>

      <div className="bg-gray-800 p-8 rounded-2xl shadow-2xl w-full max-w-md border border-gray-700 relative z-10">
        <div className="absolute top-4 left-4">
          <Link to="/" className="text-gray-400 hover:text-white flex items-center gap-1 text-sm transition-colors">
            <SafeIcon icon={FiArrowLeft} />
            <span>Back to Website</span>
          </Link>
        </div>

        <div className="text-center mb-8 mt-4">
          <div className="inline-block p-4 rounded-xl bg-gray-900/50 mb-6 border border-gray-700 shadow-inner">
            <img src={logoUrl} alt="Ramirez Mobile Clean Truck Logo" className="h-28 w-auto object-contain" />
          </div>
          <h1 className="text-2xl font-bold text-white flex items-center justify-center gap-2">
            <SafeIcon icon={FiShield} className="text-blue-500" />
            cPanel Access
          </h1>
          <p className="text-gray-400 text-sm mt-1">Authorized Personnel Only</p>
        </div>

        {error && (
          <div className="bg-red-900/20 border border-red-500 text-red-200 p-3 rounded-lg mb-6 text-sm flex items-center gap-2 animate-pulse">
            <SafeIcon icon={FiAlertCircle} />
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-gray-300 text-sm font-medium mb-2">Username / Email</label>
            <div className="relative">
              <SafeIcon icon={FiUser} className="absolute left-3 top-3.5 text-gray-500" />
              <input 
                type="text" 
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full bg-gray-700 border border-gray-600 text-white rounded-lg pl-10 pr-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none transition-all placeholder-gray-500"
                placeholder="Enter ID"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-gray-300 text-sm font-medium mb-2">Password</label>
            <div className="relative">
              <SafeIcon icon={FiLock} className="absolute left-3 top-3.5 text-gray-500" />
              <input 
                type="password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-gray-700 border border-gray-600 text-white rounded-lg pl-10 pr-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none transition-all placeholder-gray-500"
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className={`w-full bg-blue-600 text-white font-bold py-3 rounded-lg hover:bg-blue-700 transition-all transform hover:scale-[1.02] shadow-lg shadow-blue-900/50 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {loading ? 'Verifying Credentials...' : 'Log In to cPanel'}
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-gray-700 text-center">
          <p className="text-xs text-gray-500">
            Secure System • IP Logged • 256-bit Encryption
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;